import { api } from "../../api/apiSlice";

// Leave Management (2026-09-05) - web port of the legacy WinForms frm_Leave/
// Frm_Bulk_leave screens, merged into one page per direct instruction.
// Against TexasAlarms.Api's new src/Leave module (Batch129_LeaveMaster.sql).
export const leaveApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Live From-date recalculation (holidays+Sundays for that month), same
    // round trip both the bulk grid's default preview and the single-
    // employee detail panel use.
    getLeaveMonthCalc: builder.query({
      query: (params) => ({ url: "/leave/month-calc", params }),
    }),
    getLeaveTimeline: builder.query({
      query: (employeeRecordGuid) => ({ url: `/leave/timeline/${employeeRecordGuid}` }),
      providesTags: (result, error, employeeRecordGuid) => [{ type: "LeaveTimeline", id: employeeRecordGuid }],
    }),
    // One employeeRecordGuid (single-employee path) or many (bulk) - both
    // write the exact same shape of row, same call either way.
    markLeave: builder.mutation({
      query: (body) => ({ url: "/leave", method: "POST", data: body }),
      invalidatesTags: (result, error, body) => [
        { type: "LeaveEligibilitySuggestions", id: "LIST" },
        ...body.employeeRecordGuids.map((id) => ({ type: "LeaveTimeline", id })),
      ],
    }),
    // The single list the Leave Management page shows (2026-09-07,
    // Batch130+131) - "who's due for leave around the chosen target month,
    // with a consistency score", enriched with the DOP/Pending Leave/Already-
    // Marked columns folded in from the now-retired separate month-view
    // grid. Read-only/advisory, never blocks marking leave. Passing
    // employeeRecordGuid (jump-to-employee) always returns that one
    // employee's row regardless of the other filters.
    getLeaveEligibilitySuggestions: builder.query({
      query: (params) => ({ url: "/leave/eligibility-suggestions", params }),
      providesTags: [{ type: "LeaveEligibilitySuggestions", id: "LIST" }],
    }),
    // "Click the score" drill-down - one employee, trailing 12 complete
    // months, day-level (the Muster Roll modal).
    getLeaveMusterRoll: builder.query({
      query: (employeeRecordGuid) => ({ url: `/leave/muster-roll/${employeeRecordGuid}` }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetLeaveMonthCalcQuery,
  useGetLeaveTimelineQuery,
  useMarkLeaveMutation,
  useGetLeaveEligibilitySuggestionsQuery,
  useGetLeaveMusterRollQuery,
} = leaveApi;
